// Czech labels per enum type (Java simple name)

export const ENUM_LABELS = {
  InitiativeState: {
    NEW: "Nový",
    REJECT: "Zamítnutý",
    ACCEPT: "Vyřizuje se",
    REPLY: "Vyřízen",
    FORWARDED: "Postoupen",
  },
  RequestState: {
    NEW: "Nová",
    REJECT: "Zamítnutá",
    ACCEPT: "Schválená",
  },
  StatementState: {
    NEW: "Rozpracované",
    ACCEPT: "Přijaté",
    INCOMPLETE: "Neúplné",
    WRONG: "Chybné",
  },
  Visibility: {
    PUBLIC: "Veřejný",
    REQUEST: "Na žádost",
    SECRET: "Tajný",
  },
  CheckedState: {
    NOT_CHECKED: "Nezkontrolován",
    TO_CHECK: "Ke kontrole",
    CHECKED: "Zkontrolován",
  },
  ViewConsentState: {
    NONE: "Bez žádosti",
    REQUESTED: "Čeká na udělení souhlasu",
    GRANTED: "Souhlas udělen",
  },
  ReleasedState: {
    RELEASED: "Uvolněný",
    NOT_RELEASED: "Neuvolněný",
  },
};

// (entityType, fieldName) -> enum class name in ENUM_LABELS.
export const GENERIC_SCALAR_TYPES = {
  Initiative: { state: "InitiativeState" },
  Request: { state: "RequestState" },
  Statement: {
    state: "StatementState",
    visibility: "Visibility",
    checked: "CheckedState",
    viewConsentState: "ViewConsentState",
  },
  Official: {
    visibility: "Visibility",
    wpVisibility: "Visibility",
    checkedState: "CheckedState",
  },
  OfficialWorkingPosition: { released: "ReleasedState" },
  WorkingPosition: { visibility: "Visibility" },
};

/** Merge BE-fetched enum entries (e.g. HelpPlacementEnum) into the static map. */
export const registerEnumLabels = (type, entries) => {
  if (!type || !entries) return;
  const map = {};
  entries.forEach((e) => { if (e && e.id) map[e.id] = e.label || e.id; });
  ENUM_LABELS[type] = map;
};

/** Map BE enum token to Czech label, falling back to the raw token. */
export const enumLabel = (type, value) =>
  (type && ENUM_LABELS[type] && ENUM_LABELS[type][value]) || value;
